import React from 'react';
import '../Components/ComponentCss/SeeAllModal.css';
import SeeAll from "../Pages/SeeAll"; // 모달 스타일을 정의할 CSS 파일 (예시)

const SeeAllModal = ({ show, companyData, onClose }) => {
    if (!show) return null; // 모달이 보여야 할 때만 반환

    return (
        <div className="see-modal-overlay">
            <div className="see-modal-content">
               <SeeAll companyDataArr={companyData} onClose={onClose} />

            </div>
        </div>
    );
};

export default SeeAllModal;